import { createSelector } from 'reselect';

import {
    getResourceError,
    getResourceStatus,
} from './common';

const getFavoritePagesData = (state) => state.getIn(['app', 'favoritePages']);

const getFavoritePagesStatus = createSelector(getFavoritePagesData, getResourceStatus);
const getFavoritePagesError = createSelector(getFavoritePagesData, getResourceError);
const getFavoritePages = createSelector(getFavoritePagesData, (data) => data.get('favoritePages').toJS());

export {
    getFavoritePagesStatus,
    getFavoritePagesError,
    getFavoritePages,
};
